import template from './templates/tripCarItem.tmpl.html';
import tripEvents from './../config/events.constant';

export default function TripCarItem(
    l10nService,
    userService,
    tripUtils,
    moment,
) {
    'ngInject';

            return {
                restrict: 'AE',
                template,
                scope: {
                    data: '=',
                    cancellation: '=tripCarItemCancellation',
                    cancelTrip: '=tripCarItemCancelTrip',
                    regionalSettings: '=',
                    tripDetails: '=',
                    isCancelled: '=',
                    itemCannotBeCancelled: '=',
                    getTooltip: '=',
                    showAcceptDismissForBooker: '=',
                    lastReview: '=',
                },
                link: function(scope) {
                    scope.l10n = l10nService;
                    scope.countDays = tripUtils.countDays;
                    scope.userCulture = userService.getCulture();
                    scope.moment = moment;
                    scope.cancelTripItem = function(item) {
                        scope.$emit(tripEvents.TRIP_CANCEL_ITEM, item);
                    };

                    scope.showItemReviewStatus = scope.lastReview && scope.lastReview.needToShowTripItems() && scope.showAcceptDismissForBooker();
                    scope.isItemNotIndicated = function(tripItemId) {
                        return scope.showItemReviewStatus && scope.lastReview.getFirstUserReview().isTripItemIdNotInticated(tripItemId);
                    };

                    scope.isTripItemIdApproved = function(tripItemId) {
                        return scope.showItemReviewStatus && scope.lastReview.getFirstUserReview().isTripItemIdApproved(tripItemId);
                    };

                    scope.isTripItemIdDeclined = function(tripItemId) {
                        return scope.showItemReviewStatus && scope.lastReview.getFirstUserReview().isTripItemIdDeclined(tripItemId);
                    };

                    scope.isNotCCUser = scope.tripDetails.ReviewTripInfo.CanBeCommented || scope.tripDetails.ReviewTripInfo.CanBeAccepted;
                    scope.isSingleReviewer = scope.tripDetails.ReviewTripInfo.CanBeAccepted;
                    scope.tripDetails.reviewModel = scope.tripDetails.reviewModel || {flights: {}, cars: {}, hotels: {}, rails: {}};

                    scope.isItemReviewed = function(carId) {
                        return scope.tripDetails.reviewModel && scope.tripDetails.reviewModel.cars && scope.tripDetails.reviewModel.cars.hasOwnProperty(carId);
                    };

                    scope.applyReview = function(car, isAccepted) {
                        scope.tripDetails.reviewModel.cars[car.Id] = isAccepted;
                    };
                },
            };
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/directives/tripCarItem.directive.js